import NavBar from "../Components/NavBar";
import "../CSS/reporte.css";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { db } from "../FirebaseConfig/firebase";
import Button from "@mui/material/Button";

import { CSVLink } from "react-csv";

function MisReservas() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [codigosList, setCodigosList] = useState([]);
  const [datosCargados, setDatosCargados] = useState(false); // MOSTRAR BARRA DE CARGA
  const [reservasList, setReservasList] = useState([]);
  const [reservasListConPagos, setReservasListConPagos] = useState([]);

  const elementos = [
    {
      nombre: "ZONA 1",
      id: "zona1",
    },
    {
      nombre: "ZONA 2",
      id: "zona2",
    },
    {
      nombre: "ZONA 3",
      id: "zona3",
    },
    {
      nombre: "ZONA 4",
      id: "zona4",
    },
    {
      nombre: "ZONA 5",
      id: "zona5",
    },
    {
      nombre: "ZONA 6",
      id: "zona6",
    },
    {
      nombre: "CAJA CHINA 1",
      id: "caja1",
    },
    {
      nombre: "CAJA CHINA 2",
      id: "caja2",
    },
  ];

  //FOR DE FORS
  const buscarCodigos = async () => {
    const cuponesList = collection(
      db,
      `USUARIOS/${localStorage.getItem("idDocumento")}/AsientosRegistrados`
    );
    const data = await getDocs(cuponesList);
    setCodigosList(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    setDatosCargados(true);
  };
  //FOR DE FORS
  const buscarReservas = async () => {
    const data = await getDocs(
      query(
        collection(db, `PARRILLAS`),
        where("cip", "==", localStorage.getItem("idLocal"))
      )
    );

    setReservasList(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));

    data.forEach((doc) => {
      console.log(doc.data());
    }); /*
	setCodigosList(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));

    const reservasList = collection(
      db,
      `USUARIOS/${localStorage.getItem("idDocumento")}/AsientosRegistrados`
    );
    const data = await getDocs(cuponesList);
    setCodigosList(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    setDatosCargados(true);*/
  };

  const estadoDePago = (invitados) => {
    let pagados = 0;
    let noPagados = 0;

    for (const objeto of invitados) {
      if (objeto.estado === "Pagado") {
        pagados++;
      } else if (objeto.estado === "No pagado") {
        noPagados++;
      }
    }
    const resultado = `Pagado(${pagados})  , No Pagado(${noPagados})`;
    return resultado;
  };
  //cerrar cupones
  const cerrar = () => {
    navigate(`../panelUser/`);
  };
  useEffect(() => {
    buscarCodigos();
    buscarReservas();
  }, []);
  useEffect(() => {
    console.log(reservasList);

    const resultados = reservasList.map(async (objeto) => {
      const invitadosList = collection(db, `PARRILLAS/${objeto.id}/INVITADOS`);
      const q = query(invitadosList);
      const data = await getDocs(q);

      return {
        ...objeto,
        estadoPagos: estadoDePago(
          data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
        ),
      };
      //		estadoPagos: estadoDePago(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))

      //setInvitados(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
      //return `Nombre: ${objeto.nombre}, Estado: ${objeto.estado}, DNI: ${objeto.dni}`;
    });
    Promise.all(resultados)
      .then((resultados) => {
        console.log("RESULTADO");
		setReservasListConPagos(resultados)
        console.log(resultados);
      })
      .catch((error) => {
        console.error("Error:", error);
      });

    //setReservasListConPagos(resultados);
  }, [reservasList]);
  useEffect(() => {
    console.log("RESULTADO");
    console.log(reservasListConPagos);
  }, [reservasListConPagos]);
  useEffect(() => {}, [codigosList]);
  if (!datosCargados) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px auto",
          textAlign: "center",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ verticalAlign: "middle", display: "block" }}>
          <div>
            <img
              style={{ height: "300px" }}
              src={require(`../img/docucargando.gif`)}
              alt="esperando"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="panel">
      <NavBar
        titulo="MIS RESERVAS"
        nombre=""
        imagen="cerrar"
        logoTitulo="cupon"
        cerrar={cerrar}
      ></NavBar>
      <div className="reporte-cabecera">
        <h1 className="cd">Total de reservas : {reservasList.length}</h1>
      </div>

      <div className="reporte-tabla">
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell align="center">
                  <b>ZONA Y FECHA</b>
                </TableCell>

                <TableCell align="center">
                  <b>ESTADO DE PAGO</b>
                </TableCell>
				<TableCell align="center">
                  <b>OBSERVACIONES</b>
                </TableCell>
                <TableCell align="center">
                  <b>FECHA DE COMPRA</b>
                </TableCell>
                <TableCell align="center">
                  <b>TICKET</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {reservasListConPagos.map((row) => (
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">
                    {
                      elementos.find((elemento) => elemento.id === row.zona)
                        .nombre
                    }{" "}
                    ({row.fecha})
                  </TableCell>
                  <TableCell align="center">{row.estadoPagos}</TableCell>
				  <TableCell align="center">{row.observaciones}</TableCell>

                  <TableCell align="center">{row.fechaReserva}</TableCell>
                  <TableCell align="center">
                    <Button
                      variant="contained"
                      color="success"
                      onClick={() => {
                        navigate(`/zonaparrilla/${row.id}/`);
                      }}
                    >
                      Ver ticket
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

export default MisReservas;
